__turbopack_context__.v({
  "button": "WhatToPracticeSelector-module-scss-module__icDRba__button",
  "chip": "WhatToPracticeSelector-module-scss-module__icDRba__chip",
  "chips": "WhatToPracticeSelector-module-scss-module__icDRba__chips",
  "color": "WhatToPracticeSelector-module-scss-module__icDRba__color",
  "formControl": "WhatToPracticeSelector-module-scss-module__icDRba__formControl",
  "noLabel": "WhatToPracticeSelector-module-scss-module__icDRba__noLabel",
  "root": "WhatToPracticeSelector-module-scss-module__icDRba__root",
});
